// styles
import './styles/graphic.scss';
import { wrapLongLabels } from './utils/helpers';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    recessionData,
    fmtYearAbbrev,
    fmtYearFull,
    fmtMonth,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
  } = props;

  const xTicks = isMobile ? 5 : 5;
  const yTicks = isMobile ? 5 : 5;


  const calloutValueText = '0.75% to 1%';

  const ticksMobi = [
    '1/1/1982',
    '1/1/1987',
    '1/1/1992',
    '1/1/1997',
    '1/1/2002',
    '1/1/2007',
    '1/1/2012',
    '1/1/2017',
    '1/1/2022',
  ];

  const xGrid = xAxis(x)
    .tickValues(ticksMobi.map(d => new Date(d)))
    .tickFormat(d => (isMobile
      ? `\u2019${fmtYearAbbrev(d)}`
      : fmtYearFull(d)));

  // legend
  container.insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> ${d.id}`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);
 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  // add tick prefix or suffix here
  // `${d}M`
  // `$${d}`
  yGrid.selectAll('text')
    .text(d => `${d}%`);

  yGrid.selectAll('line').attr('x2', width);

  // recessions
  const recessions = g.append('g').attr('class', 'recessions');

  recessions
    .selectAll('.recession')
    .data(recessionData)
    .enter()
    .append('rect')
    .attr('class', 'recession')
    .attr('transform', d => `translate(${[x(d.start), 0]})`)
    .attr('width', d => x(d.end) - x(d.start))
    .attr('height', height)
    .style('fill', 'grey')
    .style('fill-opacity', 0.09);
  // .style('fill-opacity', 0.09);

  recessions
    .append('text')
    .attr('class', 'label-recession')
    .attr('transform', `translate(${[x(new Date('12/1/2007')) + 5, 15]})`)
    .attr('text-anchor', 'start')
    .text('Recession');

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', (d, i) => `line line-${i}`);

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // last data point
  const lastDataValue = data[1].values[data[1].values.length - 1].value;

  // connection
  lines
    .append('line')
    .attr('x1', x(x.domain()[1]))
    .attr('y1', y(lastDataValue))
    .attr('x2', x(x.domain()[1]))
    .attr('y2', y(lastDataValue) - 45)
    .attr('stroke', '#444')
    .attr('stroke-width', '1px');

  lines
    .append('line')
    .attr('x1', x(new Date('5/1/1994')))
    .attr('y1', y(4.25))
    .attr('x2', x(new Date('5/1/1994')))
    .attr('y2', y(7.75))
    .attr('stroke', '#444')
    .attr('stroke-width', '1px');

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label data-line-callout');

  label.append('text')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 0;
      const y0 = y(d0.value) - 50;
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', isMobile ? 'end' : 'end')
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      return calloutValueText;
    });
  label.append('text')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 0;
      const y0 = y(d0.value) - 68;
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', isMobile ? 'end' : 'end')
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      return 'May 4';
    });

  // dark line annotation
  label.append('text')
    .attr('transform', (d) => {
      const x0 = x(new Date('7/15/1993')) + 0;
      const y0 = y(8.75);
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', 'start')
    .text('Red lines reflect interest rates');

  label.append('text')
    .attr('transform', (d) => {
      const x0 = x(new Date('7/15/1993')) + 0;
      const y0 = y(8);
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', 'start')
    .text('rising 0.5% or more');


  label.append('circle')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date);
      const y0 = y(d0.value);
      return `translate(${[x0, y0]})`;
    })
    .style('fill', '#00bcf0')
    .attr('r', 0)
    .attr('cx', 0)
    .attr('cy', 0);
}
